import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <section id="footer" class="bg-first">
  <div class="container">
    <div class="row text-center text-xs-center text-sm-left text-md-left">
      <div class="col-xs-12 col-sm-5 col-md-5">
        <h5>Quick links</h5>
        <ul class="list-unstyled quick-links">
          <li><a href="#"><i class="fa fa-angle-double-right"></i>Home</a></li>
          <li><a href="#"><i class="fa fa-angle-double-right"></i>Dashboard</a></li>
          <li><a href="#"><i class="fa fa-angle-double-right"></i>Contact</a></li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-7 col-md-7">
        <h5>Charge Point SRL</h5>
        <ul class="list-unstyled">
          <li>RO 35288705</li>
          <li>Sos. Giurgiului nr.73-75</li>
          <li>Comuna 1 Decembrie, Bucuresti</li>
        </ul>
      </div>
     
    </div>
    <div class="row">
      <hr>
    </div>	
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center text-white">
      <p style="font-size: 0.9375rem">Copyright © 2023 Charge Point SRL. All rights reserved.</p>
      </div>
      <hr>
    </div>
  </div>
</section>
  `,
})
export class FooterComponent {
}
